/**
 * Filter PropTypes
 *
 * PropType definitions for product filtering, sorting, and search functionality.
 * Used in shop pages, product grids, and filter components.
 *
 * @module propTypes/filter
 */

import PropTypes from "prop-types";

/**
 * Filter section props shape
 * Props for a reusable filter section component
 *
 * @property {string} title - Filter section title
 * @property {Array} items - Array of filter items (strings)
 * @property {string} filterType - Type of filter (category, color, size, tag)
 * @property {Function} onFilterChange - Callback when filter is selected
 * @property {string} className - Additional CSS class
 * @property {string} buttonClass - CSS class for filter buttons
 * @property {string} emptyMessage - Message when no items found
 */
export const filterSectionPropsShape = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array,
  filterType: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  buttonClass: PropTypes.string,
  emptyMessage: PropTypes.string,
};

/**
 * Sort parameters shape
 * Represents current sort/filter state
 *
 * @property {string} sortType - Type of sort (category, color, size, tag, price)
 * @property {string|number} sortValue - Value being filtered/sorted by
 */
export const sortParamsShape = PropTypes.shape({
  sortType: PropTypes.string,
  sortValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});
